import { BehaviorSubject } from 'rxjs';

export const menuSelectedItem$ = new BehaviorSubject('');

export const getMenuSelectedItem$ = () => menuSelectedItem$;

export const setMenuSelectedItem$ = (currentSelectedItem: any) =>
  menuSelectedItem$.next(currentSelectedItem);
